import GiftTable from "./giftTable.container";

export default GiftTable;
